<template>
  <v-dialog
    persistent
    v-model="dialog"
    @keydown.esc="dialog = false"
    width="850"
    scrollable
  >
    <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
      <v-card class="elevation-3">
        <v-card-title class="primary text-h5 white--text">
          {{ modalText }}
        </v-card-title>
        <v-card-text class="pa-4">
          <v-row>
            <v-col sm="12">
              <BaseDatePickerWithText
                label="Effective Date mm/dd/yyyy"
                v-model="selectedExciseTaxRateToSpecialDistrict.EffectiveDate"
                :rules="[(v) => !!v || 'required']"
              ></BaseDatePickerWithText>
            </v-col>
          </v-row>

          <v-row>
            <v-col sm="12">
              <LuSpecialDistrict
                label="Special District"
                v-model="
                  selectedExciseTaxRateToSpecialDistrict.SpecialDistrictID
                "
              ></LuSpecialDistrict>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxRates
                label="Tax Rate"
                v-model="selectedExciseTaxRateToSpecialDistrict.TaxRateID"
              ></LuExciseTaxRates>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <LuExciseTaxTypes
                label="Tax Type"
                v-model="selectedExciseTaxRateToSpecialDistrict.TaxTypeID"
              ></LuExciseTaxTypes>
            </v-col>
          </v-row>
          <v-row>
            <v-col sm="12">
              <v-checkbox
                label="Is Active"
                v-model="selectedExciseTaxRateToSpecialDistrict.IsActive"
                :rules="[(v) => v === true || v === false || 'required']"
              ></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="saveExciseTaxRateToSpecialDistrictDetails"
            :disabled="saving"
            color="primary"
            >Save</v-btn
          >
          <v-btn outlined color="primary" @click="cancelEntry">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import {get, sync, commit, call} from 'vuex-pathify'
import ExciseTaxRateToSpecialDistrict from '@classes/ExciseTaxRateToSpecialDistrict'
//templateTODO: import lookup components you plan to use
import LuSpecialDistrict from '@components/select/single/LuSpecialDistrict'
import LuExciseTaxRates from '@components/select/single/LuExciseTaxRates'
import LuExciseTaxTypes from '@components/select/single/LuExciseTaxTypes'
export default {
  components: {
    //templateTodo: define lookup components you are using
    LuSpecialDistrict,
    LuExciseTaxRates,
    LuExciseTaxTypes,
  },
  data: () => ({
    dialog: false,
    valid: true,
    selectedExciseTaxRateToSpecialDistrict: new ExciseTaxRateToSpecialDistrict(),
    modalText: '',
  }),
  created() {},
  computed: {
    ...get('exciseTaxRateToSpecialDistrict', ['saving']),
  },
  methods: {
    handleError: call('errors/handleError'),
    ...call('exciseTaxRateToSpecialDistrict', [
      'saveExciseTaxRateToSpecialDistrict',
    ]),
    async validate() {
      this.$refs.form.validate()
    },
    editExciseTaxRateToSpecialDistrict(entry) {
      this.selectedExciseTaxRateToSpecialDistrict = new ExciseTaxRateToSpecialDistrict(
        entry
      )
      this.modalText = 'Edit Tax Rate To Special District'
      this.dialog = !this.dialog
    },
    addExciseTaxRateToSpecialDistrict() {
      this.modalText = 'Insert Tax Rate To Special District'
      this.selectedExciseTaxRateToSpecialDistrict = new ExciseTaxRateToSpecialDistrict()
      this.dialog = !this.dialog
    },
    saveExciseTaxRateToSpecialDistrictDetails() {
      this.validate().then(() => {
        if (this.valid) {
          //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
          this.saveExciseTaxRateToSpecialDistrict(
            this.selectedExciseTaxRateToSpecialDistrict.removeRelated()
          ).then(
            (res) => {
              this.$emit('refresh')
              this.selectedExciseTaxRateToSpecialDistrict = new ExciseTaxRateToSpecialDistrict()
              this.$refs.form.resetValidation()
            },
            (err) => {}
          )
          this.dialog = false
        }
      })
    },
    cancelEntry() {
      this.dialog = false
      this.selectedExciseTaxRateToSpecialDistrict = new ExciseTaxRateToSpecialDistrict()
      this.$refs.form.resetValidation()
    },
  },
}
</script>
<style></style>
